import axios from "axios";
import initializeAxios from "../util/Axios";

class DownloadSettingsService {
  constructor() {
    initializeAxios();
  }

  // GET /api/download/settings
  async getDownloadSettings() {
    const response = await axios.get("/api/downloadSettings");
    return response.data;
  }

  // PUT /api/download/settings/update
  async updateDownloadSettings({ maxGuestDownloadsPerDay, maxLoggedInDownloadsPerDay, reminderEmailIntervalHours }) {
    const response = await axios.put("/api/downloadSettings/update", {
      maxGuestDownloadsPerDay,
      maxLoggedInDownloadsPerDay,
      reminderEmailIntervalHours
    });
    return response.data;
  }
}

export default new DownloadSettingsService();
